const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingBottom: 20,
    position: 'relative',
    '&:last-child': {
      paddingBottom: 0,
    },
    '& div': {
      width: 'calc(100% - 64px)',
    },
  },
  containerWithAction: {
    width: 'calc(100% - 32px)',
  },
  label: {
    color: theme.palette.text.darkGrey,
    fontFamily: 'Calibre',
    fontSize: '1.0625rem',
    lineHeight: '1rem',
    marginBottom: 5,
    fontWeight: 600,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.125rem',
    },
  },
  value: {
    fontSize: '1.375rem',
  },
  smValue: {
    fontSize: '1.375rem',
  },
  xsValue: {
    fontSize: '1.0625rem',
    whiteSpace: `pre-wrap`,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.125rem',
    },
    [theme.breakpoints.up('md')]: {
      fontSize: '1.1875rem',
    },
  },
  icon: {
    background: theme.palette.background.lighter,
    padding: theme.spacing.unit,
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.border.lighter,
    borderRadius: '100px',
    marginRight: 20,
    width: 40,
    height: 40,
  },
  action: {
    position: 'absolute',
    right: -32,
    bottom: 0,
    color: theme.palette.primary.dark,
    width: 'auto !important',
  },
});

export default styles;
